module.exports = __webpack_public_path__ + "static/img/HSBC-small-logo-no-tagline_C.a5ccec4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HSBC-small-logo-no-tagline_C.jpg
// module id = xFFW
// module chunks = 1